import axios from "axios";
import { useMorningAuthStore } from "../../store/useMorningAuthStore";
import { useMasterAuthStore } from "../../store/useMasterAuthStore";

// 기본 axios 인스턴스
const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 10000,
});

// ✅ 요청 인터셉터
axiosInstance.interceptors.request.use(
    config => {
        const isMaster = window.location.pathname.includes("master");

        if (isMaster) {
            const { accessToken } = useMasterAuthStore.getState();
            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
        } else {
            const { accessToken, checkTokenExpiration } = useMorningAuthStore.getState();

            // 🔑 만료 여부 체크
            checkTokenExpiration();

            if (accessToken) {
                config.headers.Authorization = `Bearer ${accessToken}`;
            }
            console.log(`[AUTH-WEB-REQ] ${config.method?.toUpperCase()} ${config.url} | token=${accessToken ? accessToken.substring(0, 20) + "..." : "없음"}`);
        }

        return config;
    },
    error => Promise.reject(error),
);

// ✅ 응답 인터셉터
axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        if (error.response?.status === 401) {
            const isMaster = window.location.pathname.includes("master");
            console.log(`[AUTH-WEB-401] 401 에러 발생! URL=${error.config?.url}, 응답=${JSON.stringify(error.response?.data)}`);

            if (isMaster) {
                const { logoutToGuest } = useMasterAuthStore.getState();
                logoutToGuest();
                localStorage.removeItem("master-auth-storage");
            } else {
                const { logout } = useMorningAuthStore.getState();
                logout();
                localStorage.removeItem("auth-storage");
            }

            console.log("[AUTH-WEB-401] → /login 으로 리다이렉트");
            // 로그인 페이지로 강제 이동
            window.location.href = "/login";
        }

        return Promise.reject(error);
    },
);

export default axiosInstance;
